module.exports = __webpack_public_path__ + "media/images/auth-backimage-357f29d793b3333450f3ca4f00f4adcd.jpg";